import type { Transaction } from "@tiptap/pm/state";

/** Start positions of the textblocks a transaction touched, plus those holding the old and new caret. */
export function touchedBlocks(tr: Transaction, oldHead: number): Set<number> {
  const doc = tr.doc;
  const ranges: [number, number][] = [];
  tr.mapping.maps.forEach((map, i) => {
    const rest = tr.mapping.slice(i + 1);
    map.forEach((_a, _b, start, end) => ranges.push([rest.map(start, -1), rest.map(end, 1)]));
  });
  const head = tr.mapping.map(oldHead);
  ranges.push([head, head], [tr.selection.head, tr.selection.head]);
  const blocks = new Set<number>();
  for (const [a, b] of ranges) {
    const from = Math.max(0, Math.min(a, b) - 1);
    const to = Math.min(doc.content.size, Math.max(a, b) + 1);
    doc.nodesBetween(from, to, (node, pos) => {
      if (node.isTextblock) blocks.add(pos);
      return !node.isTextblock;
    });
  }
  return blocks;
}
